import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import HomeComponent from './components/Home/HomeComponent';
import InicioComponent from './components/Inicio/InicioComponent';
import DiaryComponent from './components/Diary/DiaryComponent';
import CertificateComponent from './components/Certificates/CertificateComponent';
import LecturerComponent from './components/Lecturers/LecturerComponent';

import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import { AuthProvider, RequireAuth } from './context/AuthContext'; // Asegúrate de usar `useAuth` para acceder al contexto
import { useEffect, useState } from 'react';
import AuthServices from './services/AuthServices';
import ChatLiveComponent from './components/ChatLive/ChatLiveComponent';

// Función para obtener cookies
const getCookie = (key) => {
  const name = key + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');
  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i].trim();
    if (cookie.indexOf(name) === 0) {
      return JSON.parse(cookie.substring(name.length, cookie.length));
    }
  }
  return null;
};

function App() {
  const navigate = useNavigate(); // Hook para navegar
  const [redirected, setRedirected] = useState(false); // Estado para controlar la redirección

  useEffect(() => {
    const userSession = getCookie('userSession');

    if (userSession && !redirected) {
      sessionStorage.setItem('token', userSession['token']);
      sessionStorage.setItem('name', userSession['name']);
      sessionStorage.setItem('country', userSession['country']);
      sessionStorage.setItem('city', userSession['city']);
      sessionStorage.setItem('email', userSession['email']);
      sessionStorage.setItem('last_name', userSession['last_name']);
      sessionStorage.setItem('id_user', userSession['id_user']);
      sessionStorage.setItem('email', userSession['email']);
      sessionStorage.setItem('id_event', userSession['id_event']);

      setRedirected(true); // Establecer el estado de redirección a true

      const is_qr = sessionStorage.getItem('is_qr');
      const is_chat = sessionStorage.getItem('is_chat');

      if (is_qr) {
        navigate('/certificados');
      } else if (is_chat) {
        navigate('/chatLive');
      } else {
        navigate('/inicio');
      }
    }
  }, [redirected, navigate]); // Dependencias de useEffect

  return (
    <Routes>
      <Route path="/inicio" element={<RequireAuth><InicioComponent /></RequireAuth>} />
      <Route path="/agenda" element={<DiaryComponent />} />
      <Route path="/conferencistas" element={<LecturerComponent />} />
      <Route path="/certificados" element={<RequireAuth><CertificateComponent /></RequireAuth>} />
      <Route path="/home" element={<HomeComponent />} />
      <Route path='/chatLive' element={<RequireAuth><ChatLiveComponent /></RequireAuth>} />
      <Route path="*" element={<Navigate to="/home" />} />
    </Routes>
  );
}

// Exportar App envuelta en Router
const AppWrapper = () => (
  <Router>
    <AuthProvider>
      <App />
    </AuthProvider>
  </Router>
);

export default AppWrapper;
